export enum CardDispenserType {
    CRT571 = 0,
    CRT541 = 1
}